function toSaoPauloNaiveTsFromParts(year, month, day, hour = 0, minute = 0, second = 0) {
  return Date.UTC(year, month - 1, day, hour, minute, second, 0);
}

export function getStatusCimNowTs(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).formatToParts(date);

  const mapped = parts.reduce((acc, part) => {
    if (part.type !== "literal") acc[part.type] = Number(part.value);
    return acc;
  }, {});

  return toSaoPauloNaiveTsFromParts(
    mapped.year,
    mapped.month,
    mapped.day,
    mapped.hour,
    mapped.minute,
    mapped.second
  );
}

function parseYmdHmsToNaiveTs(dateValue, timeValue) {
  const dateText = String(dateValue || "").trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateText)) return null;

  const timeText = String(timeValue || "").trim();
  if (timeText && !/^\d{2}:\d{2}(:\d{2})?$/.test(timeText)) return null;

  const [year, month, day] = dateText.split("-").map(Number);
  const [hour = 0, minute = 0, second = 0] = timeText
    ?timeText.split(":").map(Number)
    : [0, 0, 0];

  return toSaoPauloNaiveTsFromParts(year, month, day, hour, minute, second);
}

export function calculateStatusCimPrazo(row = {}, nowTs = getStatusCimNowTs()) {
  const inicioTs = parseYmdHmsToNaiveTs(
    row?.dataInicio ?? row?.data_inicio,
    row?.horaInicio ?? row?.hora_inicio
  );
  const previsaoTs = parseYmdHmsToNaiveTs(
    row?.dataFim ?? row?.data_fim,
    row?.horaFim ?? row?.hora_fim
  );

  const temPrevisao =
    row?.temPrevisao === true ||
    row?.temPrevisao === 1 ||
    row?.tem_previsao === true ||
    row?.tem_previsao === 1;

  if (!temPrevisao || inicioTs == null || previsaoTs == null || previsaoTs <= inicioTs) {
    return {
      prazoStatus: "none",
      prazoClasse: "none",
      prazoEtaCls: "scim-eta--none",
      prazoBlinkCls: "",
      prazoRemainingSeconds: null,
      prazoElapsedSeconds: null,
      prazoTotalSeconds: null,
      prazoRatio: null,
      prazoCritical: false,
      prazoExcedido: false,
      prazoSortValue: Number.MAX_SAFE_INTEGER,
    };
  }

  const totalSeconds = Math.max(1, Math.floor((previsaoTs - inicioTs) / 1000));
  const elapsedSeconds = Math.floor((nowTs - inicioTs) / 1000);
  const remainingSeconds = Math.floor((previsaoTs - nowTs) / 1000);
  const ratio = Math.max(0, Math.min(1, remainingSeconds / totalSeconds));
  const remainingMinutes = remainingSeconds / 60;

  if (remainingSeconds <= 0) {
    return {
      prazoStatus: "expired",
      prazoClasse: "expired",
      prazoEtaCls: "scim-eta--0-10 scim-eta--expired scim-eta--neg",
      prazoBlinkCls: "scim-eta--0-5-blink",
      prazoRemainingSeconds: remainingSeconds,
      prazoElapsedSeconds: elapsedSeconds,
      prazoTotalSeconds: totalSeconds,
      prazoRatio: 0,
      prazoCritical: true,
      prazoExcedido: true,
      prazoSortValue: remainingSeconds,
    };
  }

  if (remainingMinutes <= 15) {
    return {
      prazoStatus: "critical",
      prazoClasse: "critical",
      prazoEtaCls: "scim-eta--0-10",
      prazoBlinkCls: "scim-eta--0-5-blink",
      prazoRemainingSeconds: remainingSeconds,
      prazoElapsedSeconds: elapsedSeconds,
      prazoTotalSeconds: totalSeconds,
      prazoRatio: ratio,
      prazoCritical: true,
      prazoExcedido: false,
      prazoSortValue: remainingSeconds,
    };
  }

  if (remainingMinutes <= 60) {
    return {
      prazoStatus: "warning",
      prazoClasse: "warning",
      prazoEtaCls: "scim-eta--10-40",
      prazoBlinkCls: "",
      prazoRemainingSeconds: remainingSeconds,
      prazoElapsedSeconds: elapsedSeconds,
      prazoTotalSeconds: totalSeconds,
      prazoRatio: ratio,
      prazoCritical: false,
      prazoExcedido: false,
      prazoSortValue: remainingSeconds,
    };
  }

  if (remainingMinutes <= 180) {
    return {
      prazoStatus: "attention",
      prazoClasse: "attention",
      prazoEtaCls: "scim-eta--40-80",
      prazoBlinkCls: "",
      prazoRemainingSeconds: remainingSeconds,
      prazoElapsedSeconds: elapsedSeconds,
      prazoTotalSeconds: totalSeconds,
      prazoRatio: ratio,
      prazoCritical: false,
      prazoExcedido: false,
      prazoSortValue: remainingSeconds,
    };
  }

  return {
    prazoStatus: "safe",
    prazoClasse: "safe",
    prazoEtaCls: "scim-eta--80-100",
    prazoBlinkCls: "",
    prazoRemainingSeconds: remainingSeconds,
    prazoElapsedSeconds: elapsedSeconds,
    prazoTotalSeconds: totalSeconds,
    prazoRatio: ratio,
    prazoCritical: false,
    prazoExcedido: false,
    prazoSortValue: remainingSeconds,
  };
}

export function applyPrazoToStatusCimRows(rows = [], nowTs = getStatusCimNowTs()) {
  if (!Array.isArray(rows)) return [];

  return rows.map((row) => ({
    ...row,
    ...calculateStatusCimPrazo(row, nowTs),
  }));
}
